"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'onboarding.progress.complete': 'completado',
    'onboarding.progress.steps': 'pasos',
};
